import { getLocaleSetting } from '@onlinepayments/payments-library';
import * as Sentry from '@sentry/browser';
import dayjs from 'dayjs';

import DeliveryTimeWindow from '../interfaces/DeliveryTimeWindow';

import getDayjsLocale from './getDayjsLocale';

export function getDeliveryDate(deliveryTimeWindow: DeliveryTimeWindow, isRangeOfDays = false) {
  const dayjsSettings = getLocaleSetting().dayjs;
  const dayJSLocale = getDayjsLocale();

  try {
    if (dayjsSettings) {
      if (isRangeOfDays) {
        const from = dayjs(deliveryTimeWindow.fromLocalDateTime)
          .locale(dayJSLocale)
          .format(dayjsSettings.date);

        const to = dayjs(deliveryTimeWindow.toLocalDateTime)
          .locale(dayJSLocale)
          .format(dayjsSettings.date);

        return `${from} - ${to}`;
      } else {
        return dayjs(deliveryTimeWindow.fromLocalDateTime)
          .locale(dayJSLocale)
          .format(dayjsSettings.date);
      }
    }
  } catch (error) {
    Sentry.captureException(error);
  }

  return '';
}

export function getDeliveryTimeWindow(deliveryTimeWindow: DeliveryTimeWindow) {
  const dayjsSettings = getLocaleSetting().dayjs;

  if (dayjsSettings) {
    const from = dayjs(deliveryTimeWindow.fromLocalDateTime).format(dayjsSettings.time);
    const to = dayjs(deliveryTimeWindow.toLocalDateTime).format(dayjsSettings.time);
    return `${from} – ${to}`;
  }

  return '';
}

export function getFormattedDateTime(dateTime: string) {
  const dayjsSettings = getLocaleSetting().dayjs;

  if (dayjsSettings && dayjs(dateTime).isValid()) {
    return dayjs(dateTime).format(`${dayjsSettings.date} ${dayjsSettings.time}`);
  }

  return '';
}
